module.exports = __webpack_public_path__ + "static/IBMPlexSans-Light-c7d0b288d6e6a9823fb49fde7763868e.woff";